import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { DialogConfirmComponent, DialogConfirmData } from '../components/dialog-confirm/dialog-confirm.component';
import { DialogService } from 'primeng/dynamicdialog';

@Injectable()
export class DialogConfirmService {

  constructor(
    private readonly _dialog: DialogService) {
  }

  public show(data?: DialogConfirmData & { header?: string }) {
    const ref = this._dialog.open(DialogConfirmComponent, {
      header: data?.header ?? 'Confirmation',
      closeOnEscape: true,
      dismissableMask: false,
      closable: false,
      width: '600px',
      duplicate: false,
      baseZIndex: 100000,
      maximizable: false,
      position: 'top',
      data: {
        confirmSeverity: 'primary',
        ...data,
      },
    });

    return ref.onClose
      .pipe(
        map(x => <boolean>x)
      );
  }
}